import React from 'react';
import { createPortal } from 'react-dom';
import { AlertTriangle, X } from 'lucide-react';

const PlanSwitchWarningModal = ({ isOpen, onClose, onConfirm, message }) => {
  if (!isOpen) return null;

  const modalContent = (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999] p-4"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        margin: 0,
        padding: '1rem'
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget && onClose) {
          onClose();
        }
      }}
    >
      <div
        className="bg-white rounded-2xl w-full max-w-lg shadow-2xl border border-gray-100"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-start p-6 border-b border-gray-100">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-xl bg-orange-50 text-orange-600 flex items-center justify-center">
              <AlertTriangle className="w-6 h-6" />
            </div>
            <div>
              <h3 className="text-xl font-semibold text-gray-900">Plan Switch Warning</h3>
              <p className="text-sm text-gray-500">
                Please review before proceeding.
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="w-8 h-8 rounded-full bg-gray-100 text-gray-600 flex items-center justify-center hover:bg-gray-200 transition-colors"
            aria-label="Close"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        <div className="p-6 space-y-4">
          <p className="text-gray-800 text-base leading-relaxed">
            {message}
          </p>
          <div className="bg-orange-50 border border-orange-100 rounded-xl p-4 text-sm text-orange-800">
            Switching plans immediately resets your available tokens for the new plan tier.
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-end gap-3 p-6 border-t border-gray-100">
          <button
            onClick={onClose}
            className="w-full md:w-auto px-5 py-2.5 rounded-xl font-semibold border border-gray-200 text-gray-700 hover:bg-gray-50 transition-colors"
          >
            Keep Current Plan
          </button>
          <button
            onClick={onConfirm}
            className="w-full md:w-auto px-5 py-2.5 rounded-xl font-semibold text-white bg-gradient-to-r from-orange-500 to-red-500 shadow-lg shadow-orange-200 hover:opacity-90 transition-all"
          >
            Continue Switching
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default PlanSwitchWarningModal;

